var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.5383 9.49425C16.2572 8.83525 17.4228 8.83525 18.1416 9.49425L32.46 22.6197C32.8697 22.9952 33.0459 23.5038 32.9886 23.9938C33.0503 24.4875 32.8746 25.0014 32.4615 25.3801L18.1431 38.5056C17.4242 39.1646 16.2587 39.1646 15.5398 38.5056C14.8209 37.8466 14.8209 36.7781 15.5398 36.1191L28.7597 24.0006L15.5383 11.8807C14.8194 11.2217 14.8194 10.1532 15.5383 9.49425Z"}));
}

ArrowRightInline.defaultProps = {"className":"w-full h-full fill-white","viewBox":"0 0 48 48"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
